import { createElement } from 'react';
import { ToolbarProps } from '.';
import { BaseToolbar, BaseToolbarItem } from './__internal__';

export const Toolbar = (props: ToolbarProps) => {
  const items: BaseToolbarItem[] = props.helpPopup
    ? [...props.items, { type: 'HelpPopup', ...props.helpPopup }]
    : props.items;
  return (
    <BaseToolbar
      {...props}
      items={items.map((item) => {
        if (item.type === 'ToggleButton') {
          return {
            ...item,
            icon: item.text ? undefined : item.icon, // Do not allow icon+text toggle button
            textToDrop: undefined, // Do not allow dropping part of the text
          };
        }
        return item;
      })}
    />
  );
};
